import React, { Component } from 'react';
import { Link } from "react-router-dom";
import FlatButton from "material-ui/FlatButton/index";
import ContentCreate from "material-ui/svg-icons/content/create";

import { List, Datagrid, FilterForm } from 'components/list';
import { TextField } from 'components/field';

import * as utils from './utils';


const FunctionSwitchFilter = (props) => (
  <FilterForm name='function_switch_filter' {...props}>
  </FilterForm>
);

class ViewFunctionSwitchDetailButton extends Component {

  constructor(props) {
    super(props);
    this.clickOnLink = this.clickOnLink.bind(this);
  }

  clickOnLink(featureName) {
    localStorage.setItem(utils.localStoreKeyForCurrentFeatureName, featureName);
  }

  render() {
    const {record} = this.props;

    return (
      record.default_value === '0' &&
      <FlatButton
        primary
        label='View and Adjust Whitelist'
        icon={<ContentCreate/>}
        onClick={() => this.clickOnLink(record.display_text)}
        containerElement={<Link to={utils.getSwitchFunctionDetailUrl(record.field)}/>}
        style={{overflow: 'inherit'}}
      />
    )
  }
}

const WhitelistForTextField = (props) => {
  const {record} = props;
  if (record.default_value === '1') {
    record.number_shop = 'All shops';
  } else {
    let number_shop = 0;
    if (record.value_count) {
      for (let valueCount of record.value_count) {
        if (valueCount.value === '1') {
          number_shop = valueCount.count;
        }
      }
    }
    record.number_shop = `${number_shop} of whitelist shops`;
  }

  return (
    <TextField {...props} />
  )
};

export class FunctionSwitchList extends Component {
  render() {

    return (
      <List filters={<FunctionSwitchFilter/>} {...this.props} autoLoadData={true}>
        <Datagrid bodyOptions={{stripedRows: true, showRowHover: true}}>
          <TextField source="display_text" label="Name"/>
          <WhitelistForTextField source={'number_shop'} label="Whitelist for"/>
          <ViewFunctionSwitchDetailButton/>
        </Datagrid>
      </List>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/FunctionSwitchList.js